export default {
  state: {
    showStepSignup: false,
    showStepOrganization: false,
    step: 1,
    loading: false,
    error: null,
    isOnline: true,
    window: {
      width: 0,
      height: 0
    }
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload;
    },
    setError (state, payload) {
      state.error = payload;
    },
    clearError (state) {
      state.error = null;
    },
    setStep (state, payload) {
      state.step = payload;
    },
    setShowStepOrganization (state, payload) {
      state.showStepOrganization = payload;
    },
    setShowStepSignup (state, payload) {
      state.showStepSignup = payload;
    },
    setIsOnline (state, payload) {
      state.isOnline = payload;
    },
    setWidth (state, payload) {
      state.window.width = payload;
    },
    setHeight (state, payload) {
      state.window.height = payload;
    }
  },
  actions: {
    clearError ({commit}) {
      commit('clearError');
    },
    setError ({commit}, payload) {
      commit('setError', payload);
    },
    setStep ({commit}, payload) {
      commit('setStep', payload);
    },
    setShowStepOrganization ({commit}, payload) {
      commit('setShowStepOrganization', payload);
    },
    setShowStepSignup ({commit}, payload) {
      commit('setShowStepSignup', payload);
    },
    setIsOnline ({commit}, payload) {
      commit('setIsOnline', payload);
    },
    setWidth ({commit}, payload) {
      commit('setWidth', payload);
    },
    setHeight ({commit}, payload) {
      commit('setHeight', payload);
    }
  },
  getters: {
    loading (state) {
      return state.loading;
    },
    error (state) {
      return state.error;
    },
    step (state) {
      return state.step;
    },
    showStepOrganization (state) {
      return state.showStepOrganization;
    },
    showStepSignup (state) {
      return state.showStepSignup;
    },
    isOnline (state) {
      return state.isOnline;
    },
    width (state) {
      return state.window.width;
    },
    height (state) {
      return state.window.height;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/shared/index.js